export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14069.c3210448.jpg";